// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1aNuq","info":"PatientInfo_info__2AysK"};